// src/store/mutation-type.js
export const SET_USER = 'SET_USER'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_LOGGED_IN = 'SET_LOGGED_IN'
export const SET_LOGIN_LOADING = 'SET_LOGIN_LOADING'
export const SET_REGISTER_LOADING = 'SET_REGISTER_LOADING'
export const CLEAR_USER = 'CLEAR_USER'
export const SET_WISH_LOADING = 'SET_WISH_LOADING'
export const ADD_WISH = 'ADD_WISH'
// 其他已有的mutation type...
